import { CommonModule } from '@angular/common';
import { Component, Output, EventEmitter, Input } from '@angular/core';
import { FormsModule } from '@angular/forms';

@Component({
  selector: 'app-input',
  standalone: true,
  imports: [FormsModule, CommonModule],
  templateUrl: './input.component.html',
  styleUrl: './input.component.scss',
})
export class InputComponent {
  @Input() label = '';
  @Input() inputValue = '';
  @Input() type = '';
  @Input() placeholder = '';
  @Input() title = '';
  @Input() error = '';
  @Output() returnValue: EventEmitter<any> = new EventEmitter<string>();
  passwordVisible: boolean = false;

  showPassword(){
    this.passwordVisible = !this.passwordVisible;
  }

  onInputChange(event: any) {
    if (!this.title) {
      this.returnValue.emit(this.inputValue);
    } else {
      this.returnValue.emit({ title: this.title, value: this.inputValue });
    }
  }
}
